import WebdevelopmentImg from "../Assets/Images/Web-Development.svg";
import {
  FaReact,
  FaNodeJs,
  FaShopify,
  FaWordpressSimple,
} from "react-icons/fa";
import { SiDjango } from "react-icons/si";
import { LiaLaravel } from "react-icons/lia";

const stacks = [
  { name: "React", icon: FaReact },
  { name: "Node.Js", icon: FaNodeJs },
  { name: "WordPress", icon: FaWordpressSimple },
  { name: "Django", icon: SiDjango },
  { name: "Shopify", icon: FaShopify },
  { name: "Laravel", icon: LiaLaravel },
];

const Webdevelopment = () => {
  return (
    <div className="relative bg-night overflow-hidden">
      <div className="glow-orb w-[300px] h-[300px] bg-neonCyan/15 bottom-0 right-0"></div>
      <div className="max-w-[1140px] mx-auto py-16 p-4 relative">
        <div className="grid lg:grid-cols-2 py-10 items-center gap-10">
          <div>
            <h1
              data-aos="fade-right"
              className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white"
            >
              Web Apps <span className="text-gradient">Development</span>
            </h1>
            <div className="web3-underline w-[70px] mt-3"></div>
            <p className="py-7 text-gray-400">
              We use a variety of platforms to develop stunning web applications
              that convert.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {stacks.map((stack) => (
                <div
                  key={stack.name}
                  className="glass-card flex items-center justify-center flex-col py-6"
                >
                  <stack.icon size={55} className="text-customRed" />
                  <p className="text-gray-300 pt-4">{stack.name}</p>
                </div>
              ))}
            </div>
          </div>
          <div data-aos="fade-left" className="flex justify-end animate-float">
            <img src={WebdevelopmentImg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Webdevelopment;
